import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';
import data from "../../data/mainData.json";

import ContactForm from '../ContactForm';
import { withParams } from '../../helper/withParams';
import Error from '../section-components/error';
import Social from '../section-components/social';
import { FaBolt, FaLocationDot, FaMapLocationDot, FaRoad, FaToilet, FaTree, FaWater } from 'react-icons/fa6';
import { GiMagicGate, GiPlantSeed, GiStreetLight, GiWeightScale } from 'react-icons/gi';
import { IoBedOutline } from 'react-icons/io5';
import { FaHome, FaTrashAlt } from 'react-icons/fa';
import ProductSliderV1 from './product-slider-v1';
import { MdGridView, MdMapsHomeWork, MdVerified } from 'react-icons/md';
import { FiLoader } from 'react-icons/fi';
import ContactDetailsCard from '../ContactDetailsCard';

class ShopDetails extends Component {
	render() {

		const slug_name =
			this.props.params?.slug_name ||
			this.props.match?.params?.slug_name ||
			null;

		console.log('Found slug_name:', slug_name);
		const product = data?.propertyDetails?.find(
			(item) => item.slug_name == slug_name
		);

		console.log('dataDetails', product)
		console.log('slug_name', slug_name)


		if (!product) {
			return <Error />;
		}

		const amenityIcons = {
			"Drainage System": <FaToilet size={20} className='text-dark' />,       // or use FaBath
			"Water Pipeline": <FaWater size={20} className='text-dark' />,
			"Solar Street Lamp": <GiStreetLight size={20} className='text-dark' />,
			"Garbage Collection": <FaTrashAlt size={20} className='text-dark' />,
			"Vasthu": <FaHome size={20} className='text-dark' />,
			"Tar Road": <FaRoad size={20} className='text-dark' />,
			"EB Connection": <FaBolt size={20} className='text-dark' />,
			"Gated Community": <GiMagicGate size={20} className='text-dark' />,
			"Garden": <GiPlantSeed size={20} className='text-dark' />,
		};
		let publicUrl = process.env.PUBLIC_URL + '/'

		return <div className="ltn__shop-details-area pb-10">
			<ProductSliderV1 product={product} />
			<div className="container">
				<div className="row">
					<div className="col-lg-8 col-md-12">
						<div className="ltn__shop-details-inner ltn__page-details-inner">
							{/* <div className="ltn__blog-meta">
						<ul>
							<li className="ltn__blog-category">
							<Link to="#">Featured</Link>
							</li>
							<li className="ltn__blog-category">
							<Link className="bg-orange" to="#">For Rent</Link>
							</li>
							<li className="ltn__blog-date">
							<i className="far fa-calendar-alt" />May 19, 2021
							</li>
							<li>
							<Link to="#"><i className="far fa-comments" />35 Comments</Link>
							</li>
						</ul>
						</div> */}
							<h1 className='mt-0'>{product.title}</h1>
							<label><span className="ltn__secondary-color"><i className="flaticon-pin" /></span>{product.location}</label>
							<h4 className="title-2">Description</h4>
							{product.description.map((text, index) => (
								<p key={index}>{text}</p>
							))}

							<h4 className="title-2">Property Detail</h4>
							<div className="property-detail-info-list section-bg-1 clearfix" style={{ paddingLeft: 0 }}>
  <ul style={{ listStyle: "none", paddingLeft: 0, margin: 3}}>
    <li style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
      <MdVerified size={20} className="me-2" />
      <label className="mb-0">DTCP No:</label>
      <span style={{ marginLeft: "5px" }}>{product?.propertyDetails?.dtcp}</span>
    </li>
    <li style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
      <MdGridView size={20} className="me-2" />
      <label className="mb-0">Total Sites:</label>
      <span style={{ marginLeft: "5px" }}>{product?.propertyDetails?.totalSites}</span>
    </li>
  </ul>

  <ul style={{ listStyle: "none", paddingLeft: 0, margin: 3}}>
    <li style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
      <MdMapsHomeWork size={20} className="me-2" />
      <label className="mb-0">Plot Size:</label>
      <span style={{ marginLeft: "5px" }}>{product?.propertyDetails?.plotsize}</span>
    </li>
    <li style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
      <FiLoader size={20} className="me-2" />
      <label className="mb-0">Project Status:</label>
      <span style={{ marginLeft: "5px" }}>{product?.propertyDetails?.status}</span>
    </li>
  </ul>
</div>

							{/* <h4 className="title-2">Facts and Features</h4>
							<div className="property-detail-feature-list clearfix mb-45">
								<ul>
									{dataDetails.factsAndFeatures.map((item, index) => (
										<li key={index}>
											<div className="property-detail-feature-list-item">
												<i className={item.icon} />
												<div>
													<h6>{item.title}</h6>
													<small>{item.size}</small>
												</div>
											</div>
										</li>
									))}
								</ul>
							</div> */}


							<h4 className="title-2">From Our Gallery</h4>

							<div className="ltn__property-details-gallery mb-30">
								<div className="row">
									{product?.gallery?.map((item, idx) => (
										<div className="col-md-4 col-sm-6" key={idx}>
												<img
													className="mb-30 w-100"
													src={item.img}
													alt={`Gallery ${idx + 1}`}
												/>
										</div>
									))}
								</div>
							</div>

							<h4 className="title-2">Project Layout</h4>
							<div className="ltn__property-details-gallery mb-30">
								<div className="row">
									
									<div className="col-md-12">
										<img className="mb-30" src={product?.layout?.image} style={{ width : "100%", height: "500px", objectFit: 'contain'}} />


									</div>
								
								



								</div>
							</div>

							<h4 className="title-2 mb-10">Amenities</h4>
							<div className="property-details-amenities mb-60">
								<div className="row">
									{[0, 1, 2].map((colIndex) => (
										<div className="col-lg-4 col-md-6" key={colIndex}>
											<div className="ltn__menu-widget">
												<ul>
													{product.amenities
														.slice(colIndex * 3, colIndex * 3 + 3)
														.map((amenity, index) => (
															<li key={index}>
																<label className="checkbox-item">
																	<span style={{ marginRight: "8px" }}>
																		{amenityIcons[amenity]}	 {amenity}
																	</span>

																</label>
															</li>
														))}
												</ul>
											</div>
										</div>
									))}
								</div>
							</div>

							<h4 className="title-2">Location</h4>
							<div className="property-details-google-map mb-80">
									<iframe
									src={product?.locationMap?.embedUrl}
									width="100%"
									height="100%"
									frameBorder="0"
									style={{ border: 0 }}
									allowFullScreen
									aria-hidden="false"
									tabIndex="0"
								/>
								
								<p className=''>Site Address : {product?.address}</p>
							</div>
							

							<h4 className="title-2 mt-5">Floor Plans</h4>


							{/* <div className="tab-content">
							<div className="tab-pane fade" id="liton_tab_3_1">
							<div className="ltn__apartments-tab-content-inner">
								<div className="row">
								<div className="col-lg-7">
									<div className="apartments-plan-img">
									<img src={publicUrl+"assets/img/others/10.png"} alt="#" />
									</div>
								</div>
								<div className="col-lg-5">
									<div className="apartments-plan-info ltn__secondary-bg--- text-color-white---">
									<h2>First Floor</h2>
									<p>Enimad minim veniam quis nostrud exercitation ullamco laboris.
										Lorem ipsum dolor sit amet cons aetetur adipisicing elit sedo
										eiusmod tempor.Incididunt labore et dolore magna aliqua.
										sed ayd minim veniam.</p>
									</div>
								</div>
								<div className="col-lg-12">
									<div className="product-details-apartments-info-list  section-bg-1">
									<div className="row">
										<div className="col-lg-6">
										<div className="apartments-info-list apartments-info-list-color mt-40---">
											<ul>
											<li><label>Total Area</label> <span>2800 Sq. Ft</span></li>
											<li><label>Bedroom</label> <span>150 Sq. Ft</span></li>
											</ul>
										</div>
										</div>
										<div className="col-lg-6">
										<div className="apartments-info-list apartments-info-list-color mt-40---">
											<ul>
											<li><label>Belcony/Pets</label> <span>Allowed</span></li>
											<li><label>Lounge</label> <span>650 Sq. Ft</span></li>
											</ul>
										</div>
										</div>
									</div>
									</div>
								</div>
								</div>
							</div>
							</div>
							<div className="tab-pane fade active show" id="liton_tab_3_2">
							<div className="ltn__product-tab-content-inner">
								<div className="row">
								<div className="col-lg-7">
									<div className="apartments-plan-img">
									<img src={publicUrl+"assets/img/others/10.png"} alt="#" />
									</div>
								</div>
								<div className="col-lg-5">
									<div className="apartments-plan-info ltn__secondary-bg--- text-color-white---">
									<h2>Second Floor</h2>
									<p>Enimad minim veniam quis nostrud exercitation ullamco laboris.
										Lorem ipsum dolor sit amet cons aetetur adipisicing elit sedo
										eiusmod tempor.Incididunt labore et dolore magna aliqua.
										sed ayd minim veniam.</p>
									</div>
								</div>
								<div className="col-lg-12">
									<div className="product-details-apartments-info-list  section-bg-1">
									<div className="row">
										<div className="col-lg-6">
										<div className="apartments-info-list apartments-info-list-color mt-40---">
											<ul>
											<li><label>Total Area</label> <span>2800 Sq. Ft</span></li>
											<li><label>Bedroom</label> <span>150 Sq. Ft</span></li>
											</ul>
										</div>
										</div>
										<div className="col-lg-6">
										<div className="apartments-info-list apartments-info-list-color mt-40---">
											<ul>
											<li><label>Belcony/Pets</label> <span>Allowed</span></li>
											<li><label>Lounge</label> <span>650 Sq. Ft</span></li>
											</ul>
										</div>
										</div>
									</div>
									</div>
								</div>
								</div>
							</div>
							</div>
							<div className="tab-pane fade" id="liton_tab_3_3">
							<div className="ltn__product-tab-content-inner">
								<div className="row">
								<div className="col-lg-7">
									<div className="apartments-plan-img">
									<img src={publicUrl+"assets/img/others/10.png"} alt="#" />
									</div>
								</div>
								<div className="col-lg-5">
									<div className="apartments-plan-info ltn__secondary-bg--- text-color-white---">
									<h2>Third Floor</h2>
									<p>Enimad minim veniam quis nostrud exercitation ullamco laboris.
										Lorem ipsum dolor sit amet cons aetetur adipisicing elit sedo
										eiusmod tempor.Incididunt labore et dolore magna aliqua.
										sed ayd minim veniam.</p>
									</div>
								</div>
								<div className="col-lg-12">
									<div className="product-details-apartments-info-list  section-bg-1">
									<div className="row">
										<div className="col-lg-6">
										<div className="apartments-info-list apartments-info-list-color mt-40---">
											<ul>
											<li><label>Total Area</label> <span>2800 Sq. Ft</span></li>
											<li><label>Bedroom</label> <span>150 Sq. Ft</span></li>
											</ul>
										</div>
										</div>
										<div className="col-lg-6">
										<div className="apartments-info-list apartments-info-list-color mt-40---">
											<ul>
											<li><label>Belcony/Pets</label> <span>Allowed</span></li>
											<li><label>Lounge</label> <span>650 Sq. Ft</span></li>
											</ul>
										</div>
										</div>
									</div>
									</div>
								</div>
								</div>
							</div>
							</div>
							
						</div> */}

							<div className="ltn__apartments-plan-area product-details-apartments-plan">
								<div className="ltn__tab-menu ltn__tab-menu-3 text-uppercase text-center">
									<div className="nav">
										{product.floorPlans.map((item, index) => (
											<a
												key={index}
												className={index == 0 ? "active show" : ""}
												data-bs-toggle="tab"
												href={`#floor_${index}`}
											>
												{item.bhk}
											</a>
										))}
									</div>
								</div>

	
								<div className="tab-content mt-0">
									{product.floorPlans.map((item, index) => (
										<div
											key={index}
											id={`floor_${index}`}
											className={`tab-pane fade ${index == 0 ? "show active" : ""}`}
										>
											<div className="ltn__slide-one-active slick-slide-arrow-1 slick-slide-dots-1">
												{item.facingOptions?.map((facing, fIndex) => (
													<div className="single-slide" key={fIndex}>

														<div className="row">
															<div className="col-lg-1" />

															<div className="col-lg-10">
																<div className="apartments-plan-img">
																	<img
																		src={facing.image}
																		alt={facing.facing}
																		className="img-fluid"
																		style={{ width : "100%", height: "500px", objectFit: 'contain'}}
																	/>
																</div>
															</div>
															<div className="col-lg-1" />

															<div className="col-lg-12 p-0">
  <div className="product-details-apartments-info-list section-bg-1 p-2">
    <div className="row g-2">
      <div className="col-lg-6">
        <ul className="apartments-info-list apartments-info-list-color mb-0">
          <li className="d-flex mb-1">
            <label className="me-3" style={{ minWidth: "140px" }}>
              Land Facing:
            </label>
            <span>{facing.details.landFacing}</span>
          </li>

          <li className="d-flex mb-1">
            <label className="me-3" style={{ minWidth: "140px" }}>
              Building Facing:
            </label>
            <span>{facing.details.buildFacing}</span>
          </li>
        </ul>
      </div>

      <div className="col-lg-6">
        <ul className="apartments-info-list apartments-info-list-color mb-0">
          <li className="d-flex mb-1">
            <label className="me-3" style={{ minWidth: "140px" }}>
              Building Area:
            </label>
            <span>{facing.details.buildarea}</span>
          </li>

          <li className="d-flex mb-1">
            <label className="me-3" style={{ minWidth: "140px" }}>
              Land Area:
            </label>
            <span>{facing.details.landarea}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>


														</div>
													</div>
												))}
											</div>
										</div>
									))}
								</div>
							</div>

							{/* APARTMENTS PLAN AREA END */}
							<h4 className="title-2">Property Video</h4>
							{/* <div className="ltn__video-bg-img ltn__video-popup-height-500 bg-overlay-black-50 bg-image mb-60" data-bs-bg={publicUrl + "assets/img/others/5.jpg"}>
								<a className="ltn__video-icon-2 ltn__video-icon-2-border---" href="https://www.youtube.com/embed/eWUxqVFBq74?autoplay=1&showinfo=0" data-rel="lightcase:myCollection">
									<i className="fa fa-play" />
								</a>
							</div> */}

							<div className="about-us-img-wrap about-img-left">
								<video
									width="100%"
									height="500px"
									style={{ objectFit: "contain"}}
									controls
									controlsList="nodownload"
									disablePictureInPicture
									onContextMenu={(e) => e.preventDefault()}
									autoPlay
									loop
									muted
									src={product?.video?.youtubeUrl}
								>
								</video>
							</div>

							{/* <div className="ltn__shop-details-tab-content-inner--- ltn__shop-details-tab-inner-2 ltn__product-details-review-inner mb-60">
								<h4 className="title-2">Customer Reviews</h4>
								<div className="product-ratting">
									<ul>
										<li><a href="#"><i className="fas fa-star" /></a></li>
										<li><a href="#"><i className="fas fa-star" /></a></li>
										<li><a href="#"><i className="fas fa-star" /></a></li>
										<li><a href="#"><i className="fas fa-star-half-alt" /></a></li>
										<li><a href="#"><i className="far fa-star" /></a></li>
										<li className="review-total"> <a href="#"> ( 95 Reviews )</a></li>
									</ul>
								</div>
								<hr />
							
								<div className="ltn__comment-area mb-30">
									<div className="ltn__comment-inner">
										<ul>
											<li>
												<div className="ltn__comment-item clearfix">
													<div className="ltn__commenter-img">
														<img src={publicUrl + "assets/img/testimonial/1.jpg"} alt="Image" />
													</div>
													<div className="ltn__commenter-comment">
														<h6><a href="#">Adam Smit</a></h6>
														<div className="product-ratting">
															<ul>
																<li><a href="#"><i className="fas fa-star" /></a></li>
																<li><a href="#"><i className="fas fa-star" /></a></li>
																<li><a href="#"><i className="fas fa-star" /></a></li>
																<li><a href="#"><i className="fas fa-star-half-alt" /></a></li>
																<li><a href="#"><i className="far fa-star" /></a></li>
															</ul>
														</div>
														<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Doloribus, omnis fugit corporis iste magnam ratione.</p>
														<span className="ltn__comment-reply-btn">September 3, 2020</span>
													</div>
												</div>
											</li>
											<li>
												<div className="ltn__comment-item clearfix">
													<div className="ltn__commenter-img">
														<img src={publicUrl + "assets/img/testimonial/3.jpg"} alt="Image" />
													</div>
													<div className="ltn__commenter-comment">
														<h6><a href="#">Adam Smit</a></h6>
														<div className="product-ratting">
															<ul>
																<li><a href="#"><i className="fas fa-star" /></a></li>
																<li><a href="#"><i className="fas fa-star" /></a></li>
																<li><a href="#"><i className="fas fa-star" /></a></li>
																<li><a href="#"><i className="fas fa-star-half-alt" /></a></li>
																<li><a href="#"><i className="far fa-star" /></a></li>
															</ul>
														</div>
														<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Doloribus, omnis fugit corporis iste magnam ratione.</p>
														<span className="ltn__comment-reply-btn">September 2, 2020</span>
													</div>
												</div>
											</li>
											<li>
												<div className="ltn__comment-item clearfix">
													<div className="ltn__commenter-img">
														<img src={publicUrl + "assets/img/testimonial/2.jpg"} alt="Image" />
													</div>
													<div className="ltn__commenter-comment">
														<h6><a href="#">Adam Smit</a></h6>
														<div className="product-ratting">
															<ul>
																<li><a href="#"><i className="fas fa-star" /></a></li>
																<li><a href="#"><i className="fas fa-star" /></a></li>
																<li><a href="#"><i className="fas fa-star" /></a></li>
																<li><a href="#"><i className="fas fa-star-half-alt" /></a></li>
																<li><a href="#"><i className="far fa-star" /></a></li>
															</ul>
														</div>
														<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Doloribus, omnis fugit corporis iste magnam ratione.</p>
														<span className="ltn__comment-reply-btn">September 2, 2020</span>
													</div>
												</div>
											</li>
										</ul>
									</div>
								</div>
								
								<div className="ltn__comment-reply-area ltn__form-box mb-30">
									<form action="#">
										<h4>Add a Review</h4>
										<div className="mb-30">
											<div className="add-a-review">
												<h6>Your Ratings:</h6>
												<div className="product-ratting">
													<ul>
														<li><a href="#"><i className="fas fa-star" /></a></li>
														<li><a href="#"><i className="fas fa-star" /></a></li>
														<li><a href="#"><i className="fas fa-star" /></a></li>
														<li><a href="#"><i className="fas fa-star" /></a></li>
														<li><a href="#"><i className="fas fa-star" /></a></li>
													</ul>
												</div>
											</div>
										</div>
										<div className="input-item input-item-textarea ltn__custom-icon">
											<textarea placeholder="Type your comments...." defaultValue={""} />
										</div>
										<div className="input-item input-item-name ltn__custom-icon">
											<input type="text" placeholder="Type your name...." />
										</div>
										<div className="input-item input-item-email ltn__custom-icon">
											<input type="email" placeholder="Type your email...." />
										</div>
										<div className="input-item input-item-website ltn__custom-icon">
											<input type="text" name="website" placeholder="Type your website...." />
										</div>
										<label className="mb-0"><input type="checkbox" name="agree" /> Save my name, email, and website in this browser for the next time I comment.</label>
										<div className="btn-wrapper">
											<button className="btn theme-btn-1 btn-effect-1 text-uppercase" type="submit">Submit</button>
										</div>
									</form>
								</div>
							</div> */}

							{/* <h4 className="title-2">Related Properties</h4>
							<div className="row">
			
								<div className="col-xl-6 col-sm-6 col-12 go-top">
									<div className="ltn__product-item ltn__product-item-4 ltn__product-item-5 text-center---">
										<div className="product-img">
											<Link to="/shop"><img src={publicUrl + "assets/img/product-3/1.jpg"} alt="#" /></Link>
											<div className="real-estate-agent">
												<div className="agent-img">
													<Link to="/team-details"><img src={publicUrl + "assets/img/blog/author.jpg"} alt="#" /></Link>
												</div>
											</div>
										</div>
										<div className="product-info">
											<div className="product-badge">
												<ul>
													<li className="sale-badg">For Rent</li>
												</ul>
											</div>
											<h2 className="product-title"><Link to="/shop">New Apartment Nice View</Link></h2>
											<div className="product-img-location">
												<ul>
													<li>
														<Link to="/shop"><i className="flaticon-pin" /> Belmont Gardens, Chicago</Link>
													</li>
												</ul>
											</div>
											<ul className="ltn__list-item-2--- ltn__list-item-2-before--- ltn__plot-brief">
												<li><span>3 </span>
													Bedrooms
												</li>
												<li><span>2 </span>
													Bathrooms
												</li>
												<li><span>3450 </span>
													square Ft
												</li>
											</ul>
											<div className="product-hover-action">
												<ul>
													<li>
														<a href="#" title="Quick View" data-bs-toggle="modal" data-bs-target="#quick_view_modal">
															<i className="flaticon-expand" />
														</a>
													</li>
													<li>
														<a href="#" title="Wishlist" data-bs-toggle="modal" data-bs-target="#liton_wishlist_modal">
															<i className="flaticon-heart-1" /></a>
													</li>
													<li>
														<Link to="/shop" title="Compare">
															<i className="flaticon-add" />
														</Link>
													</li>
												</ul>
											</div>
										</div>
										<div className="product-info-bottom">
											<div className="product-price">
												<span>$349,00<label>/Month</label></span>
											</div>
										</div>
									</div>
								</div>
							
								<div className="col-xl-6 col-sm-6 col-12 go-top">
									<div className="ltn__product-item ltn__product-item-4 ltn__product-item-5 text-center---">
										<div className="product-img">
											<Link to="/shop"><img src={publicUrl + "assets/img/product-3/2.jpg"} alt="#" /></Link>
											<div className="real-estate-agent">
												<div className="agent-img">
													<Link to="/team-details"><img src={publicUrl + "assets/img/blog/author.jpg"} alt="#" /></Link>
												</div>
											</div>
										</div>
										<div className="product-info">
											<div className="product-badge">
												<ul>
													<li className="sale-badg">For Sale</li>
												</ul>
											</div>
											<h2 className="product-title"><Link to="/shop">New Apartment Nice View</Link></h2>
											<div className="product-img-location">
												<ul>
													<li>
														<Link to="/shop"><i className="flaticon-pin" /> Belmont Gardens, Chicago</Link>
													</li>
												</ul>
											</div>
											<ul className="ltn__list-item-2--- ltn__list-item-2-before--- ltn__plot-brief">
												<li><span>3 </span>
													Bedrooms
												</li>
												<li><span>2 </span>
													Bathrooms
												</li>
												<li><span>3450 </span>
													square Ft
												</li>
											</ul>
											<div className="product-hover-action">
												<ul>
													<li>
														<a href="#" title="Quick View" data-bs-toggle="modal" data-bs-target="#quick_view_modal">
															<i className="flaticon-expand" />
														</a>
													</li>
													<li>
														<a href="#" title="Wishlist" data-bs-toggle="modal" data-bs-target="#liton_wishlist_modal">
															<i className="flaticon-heart-1" /></a>
													</li>
													<li>
														<a href="portfolio-details.html" title="Compare">
															<i className="flaticon-add" />
														</a>
													</li>
												</ul>
											</div>
										</div>
										<div className="product-info-bottom">
											<div className="product-price">
												<span>$349,00<label>/Month</label></span>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div className="row ltn__product-slider-item-three-active--- slick-arrow-1">
								{data?.properties?.products?.slice(0, 2).map(item => (
									<div key={item.id} className="col-xl-6 col-sm-6 col-12">
										<div className="ltn__product-item ltn__product-item-4">
											<div
												className="product-img go-top"
												style={{ position: "relative" }}
											>
												<Link to={`/project/${item.slug_name}`}>
													<img src={publicUrl + "assets/img/product-3/2.jpg"} alt="#" />
												</Link>
												<div className="product-badge">
													<ul>
														<li className="sale-badge bg-green---">{item?.type}</li>
													</ul>
												</div>

											</div>




											<div className="product-info">
												<div className="product-badge">
											<ul>
											<li className="sale-badg">{item.type}</li>
											</ul>
										</div>

												<h5 className="">
													<Link to={`/project/${item.slug_name}`}>{item.title}</Link>
												</h5>

												<div className="product-img-location">
													<ul>
														<li>
															<Link to="/contact">
																<FaLocationDot /> {item.location}
															</Link>
														</li>
														<li>
															<Link to="/contact">
																<FaMapLocationDot /> {item.address}
															</Link>
														</li>
														<li>
															<Link to="/contact">
																<GiWeightScale /> {item.totalsite}
															</Link>
														</li>
														<li>
															<Link to="/contact">
																<IoBedOutline /> {item.beds}
															</Link>
														</li>
													</ul>
												</div>

												<ul className="ltn__plot-brief">
											<li><span>{item.beds}</span> Bed</li>
											<li><span>{item.baths}</span> Bath</li>
											<li><span>{item.area}</span> Square Ft</li>
										</ul>
											</div>



											<div className="product-info-bottom">
												<div className="product-price fs-6">
													<Link to={`/project/${item.slug_name}`}>
														<span className=''>View More</span>
													</Link>
												</div>
											</div>
										</div>
									</div>
								))}
							</div> */}
						</div>
					</div>
					<div className="col-lg-4">
						<aside className="sidebar ltn__shop-sidebar ltn__right-sidebar---">

							{/* <div className="widget ltn__form-widget">
								<h4 className="ltn__widget-title ltn__widget-title-border-2">Drop Messege For Book</h4>
								<form action="#">
									<input type="text" name="yourname" placeholder="Your Name*" />
									<input type="text" name="youremail" placeholder="Your e-Mail*" />
									<textarea name="yourmessage" placeholder="Write Message..." defaultValue={""} />
									<button type="submit" className="btn theme-btn-1">Send Messege</button>
								</form>
							</div> */}
							<ContactForm />
							
							{/* Top Rated Product Widget */}
							{/* <div className="widget ltn__top-rated-product-widget go-top mt-3">
								<h4 className="ltn__widget-title ltn__widget-title-border-2">Top Rated Product</h4>
								<ul>
									<li>
										<div className="top-rated-product-item clearfix">
											<div className="top-rated-product-img">
												<Link to="/product-details"><img src={publicUrl + "assets/img/product/1.png"} alt="#" /></Link>
											</div>
											<div className="top-rated-product-info">
												<div className="product-ratting">
													<ul>
														<li><a href="#"><i className="fas fa-star" /></a></li>
														<li><a href="#"><i className="fas fa-star" /></a></li>
														<li><a href="#"><i className="fas fa-star" /></a></li>
														<li><a href="#"><i className="fas fa-star" /></a></li>
														<li><a href="#"><i className="fas fa-star" /></a></li>
													</ul>
												</div>
												<h6><Link to="/shop">Luxury House In Greenville </Link></h6>
												<div className="product-price">
													<span>$30,000.00</span>
													<del>$35,000.00</del>
												</div>
											</div>
										</div>
									</li>
									<li>
										<div className="top-rated-product-item clearfix">
											<div className="top-rated-product-img">
												<Link to="/product-details"><img src={publicUrl + "assets/img/product/2.png"} alt="#" /></Link>
											</div>
											<div className="top-rated-product-info">
												<div className="product-ratting">
													<ul>
														<li><a href="#"><i className="fas fa-star" /></a></li>
														<li><a href="#"><i className="fas fa-star" /></a></li>
														<li><a href="#"><i className="fas fa-star" /></a></li>
														<li><a href="#"><i className="fas fa-star" /></a></li>
														<li><a href="#"><i className="fas fa-star" /></a></li>
													</ul>
												</div>
												<h6><Link to="/shop">Apartment with Subunits</Link></h6>
												<div className="product-price">
													<span>$30,000.00</span>
													<del>$35,000.00</del>
												</div>
											</div>
										</div>
									</li>
									<li>
										<div className="top-rated-product-item clearfix">
											<div className="top-rated-product-img">
												<Link to="/product-details"><img src={publicUrl + "assets/img/product/3.png"} alt="#" /></Link>
											</div>
											<div className="top-rated-product-info">
												<div className="product-ratting">
													<ul>
														<li><a href="#"><i className="fas fa-star" /></a></li>
														<li><a href="#"><i className="fas fa-star" /></a></li>
														<li><a href="#"><i className="fas fa-star" /></a></li>
														<li><a href="#"><i className="fas fa-star-half-alt" /></a></li>
														<li><a href="#"><i className="far fa-star" /></a></li>
													</ul>
												</div>
												<h6><Link to="/shop">3 Rooms Manhattan</Link></h6>
												<div className="product-price">
													<span>$30,000.00</span>
													<del>$35,000.00</del>
												</div>
											</div>
										</div>
									</li>
								</ul>
							</div> */}
							{/* Menu Widget (Category) */}
							{/* <div className="widget ltn__menu-widget ltn__menu-widget-2--- ltn__menu-widget-2-color-2---">
								<h4 className="ltn__widget-title ltn__widget-title-border-2">Top Categories</h4>
								<ul className="go-top">
									<li><Link to="/blog-grid">Apartments <span>(26)</span></Link></li>
									<li><Link to="/blog-grid">Picture Stodio <span>(30)</span></Link></li>
									<li><Link to="/blog-grid">Office  <span>(71)</span></Link></li>
									<li><Link to="/blog-grid">Luxary Vilas <span>(56)</span></Link></li>
									<li><Link to="/blog-grid">Duplex House <span>(60)</span></Link></li>
								</ul>
							</div> */}

							<div className="widget ltn__author-widget mt-4">
								<div className="ltn__author-widget-inner text-center">
									<img src={data?.owner?.profile_img} alt="Image" />
									<h5>{data?.owner?.name}</h5>
									<small>{data?.owner?.degree}</small>
									{/* <div className="product-ratting">
										<ul>
											<li><a href="#"><i className="fas fa-star" /></a></li>
											<li><a href="#"><i className="fas fa-star" /></a></li>
											<li><a href="#"><i className="fas fa-star" /></a></li>
											<li><a href="#"><i className="fas fa-star-half-alt" /></a></li>
											<li><a href="#"><i className="far fa-star" /></a></li>
											<li className="review-total"> <a href="#"> ( 1 Reviews )</a></li>
										</ul>
									</div> */}
									<p>{data?.owner?.description}</p>
									{/* <div className="ltn__social-media">
										<ul>
											<li><a href="#" title="Facebook"><i className="fab fa-facebook-f" /></a></li>
											<li><a href="#" title="Twitter"><i className="fab fa-twitter" /></a></li>
											<li><a href="#" title="Linkedin"><i className="fab fa-linkedin" /></a></li>
											<li><a href="#" title="Youtube"><i className="fab fa-youtube" /></a></li>
										</ul>
									</div> */}
									<Social />
								</div>
							</div>

							{/* <div className="widget ltn__search-widget">
								<h4 className="ltn__widget-title ltn__widget-title-border-2">Search Objects</h4>
								<form action="#">
									<input type="text" name="search" placeholder="Search your keyword..." />
									<button type="submit"><i className="fas fa-search" /></button>
								</form>
							</div> */}
							{/* <div className="widget ltn__popular-product-widget">
								<h4 className="ltn__widget-title ltn__widget-title-border-2">
									Popular Properties
								</h4>

								<div className="row ltn__popular-product-widget-active slick-arrow-1">
									{data?.properties?.products.map(item => (
										<div key={item.id} className="col-xl-4 col-sm-6 col-12">
											<div className="ltn__product-item ltn__product-item-4 ">
												<div
													className="product-img go-top"
													style={{ position: "relative" }}
												>
													<Link to={`/project/${item.slug_name}`}>
														<img src={publicUrl + "assets/img/product-3/2.jpg"} alt="#" />
													</Link>
													<div className="product-badge">
														<ul>
															<li className="sale-badge bg-green---">{item?.type}</li>
														</ul>
													</div>

												</div>




												<div className="product-info">
													<div className="product-badge">
											<ul>
											<li className="sale-badg">{item.type}</li>
											</ul>
										</div>

													<h5 className="">
														<Link to={`/project/${item.slug_name}`}>{item.title}</Link>
													</h5>

													<div className="product-img-location">
														<ul>
															<li>
																<Link to="/contact">
																	<FaLocationDot /> {item.location}
																</Link>
															</li>
															<li>
																<Link to="/contact">
																	<FaMapLocationDot /> {item.address}
																</Link>
															</li>
															<li>
																<Link to="/contact">
																	<GiWeightScale /> {item.totalsite}
																</Link>
															</li>
															<li>
																<Link to="/contact">
																	<IoBedOutline /> {item.beds}
																</Link>
															</li>
														</ul>
													</div>

													<ul className="ltn__plot-brief">
											<li><span>{item.beds}</span> Bed</li>
											<li><span>{item.baths}</span> Bath</li>
											<li><span>{item.area}</span> Square Ft</li>
										</ul>
												</div>



												<div className="product-info-bottom">
													<div className="product-price fs-6">
														<Link to={`/project/${item.slug_name}`}>
															<span className=''>View More</span>
														</Link>
													</div>
												</div>
											</div>
										</div>
									))}
								</div>
							</div> */}


							{/* <div className="widget ltn__popular-post-widget go-top">
								<h4 className="ltn__widget-title ltn__widget-title-border-2">Leatest Blogs</h4>
								<ul>
									<li>
										<div className="popular-post-widget-item clearfix">
											<div className="popular-post-widget-img">
												<Link to="/blog-details"><img src={publicUrl + "assets/img/team/5.jpg"} alt="#" /></Link>
											</div>
											<div className="popular-post-widget-brief">
												<h6><Link to="/blog-details">Lorem ipsum dolor sit
													cing elit, sed do.</Link></h6>
												<div className="ltn__blog-meta">
													<ul>
														<li className="ltn__blog-date">
															<a href="#"><i className="far fa-calendar-alt" />June 22, 2020</a>
														</li>
													</ul>
												</div>
											</div>
										</div>
									</li>
									<li>
										<div className="popular-post-widget-item clearfix">
											<div className="popular-post-widget-img">
												<Link to="/blog-details"><img src={publicUrl + "assets/img/team/6.jpg"} alt="#" /></Link>
											</div>
											<div className="popular-post-widget-brief">
												<h6><Link to="/blog-details">Lorem ipsum dolor sit
													cing elit, sed do.</Link></h6>
												<div className="ltn__blog-meta">
													<ul>
														<li className="ltn__blog-date">
															<a href="#"><i className="far fa-calendar-alt" />June 22, 2020</a>
														</li>
													</ul>
												</div>
											</div>
										</div>
									</li>
									<li>
										<div className="popular-post-widget-item clearfix">
											<div className="popular-post-widget-img">
												<Link to="/blog-details"><img src={publicUrl + "assets/img/team/7.jpg"} alt="#" /></Link>
											</div>
											<div className="popular-post-widget-brief">
												<h6><Link to="/blog-details">Lorem ipsum dolor sit
													cing elit, sed do.</Link></h6>
												<div className="ltn__blog-meta">
													<ul>
														<li className="ltn__blog-date">
															<a href="#"><i className="far fa-calendar-alt" />June 22, 2020</a>
														</li>
													</ul>
												</div>
											</div>
										</div>
									</li>
									<li>
										<div className="popular-post-widget-item clearfix">
											<div className="popular-post-widget-img">
												<Link to="/blog-details"><img src={publicUrl + "assets/img/team/8.jpg"} alt="#" /></Link>
											</div>
											<div className="popular-post-widget-brief">
												<h6><Link to="/blog-details">Lorem ipsum dolor sit
													cing elit, sed do.</Link></h6>
												<div className="ltn__blog-meta">
													<ul>
														<li className="ltn__blog-date">
															<a href="#"><i className="far fa-calendar-alt" />June 22, 2020</a>
														</li>
													</ul>
												</div>
											</div>
										</div>
									</li>
								</ul>
							</div>
			
							<div className="widget ltn__social-media-widget">
								<h4 className="ltn__widget-title ltn__widget-title-border-2">Follow us</h4>
								<div className="ltn__social-media-2">
									<ul>
										<li><a href="#" title="Facebook"><i className="fab fa-facebook-f" /></a></li>
										<li><a href="#" title="Twitter"><i className="fab fa-twitter" /></a></li>
										<li><a href="#" title="Linkedin"><i className="fab fa-linkedin" /></a></li>
										<li><a href="#" title="Instagram"><i className="fab fa-instagram" /></a></li>
									</ul>
								</div>
							</div>
							
							<div className="widget ltn__tagcloud-widget go-top">
								<h4 className="ltn__widget-title ltn__widget-title-border-2">Popular Tags</h4>
								<ul>
									<li><Link to="/blog-grid">Popular</Link></li>
									<li><Link to="/blog-grid">desgin</Link></li>
									<li><Link to="/blog-grid">ux</Link></li>
									<li><Link to="/blog-grid">usability</Link></li>
									<li><Link to="/blog-grid">develop</Link></li>
									<li><Link to="/blog-grid">icon</Link></li>
									<li><Link to="/blog-grid">Car</Link></li>
									<li><Link to="/blog-grid">Service</Link></li>
									<li><Link to="/blog-grid">Repairs</Link></li>
									<li><Link to="/blog-grid">Auto Parts</Link></li>
									<li><Link to="/blog-grid">Oil</Link></li>
									<li><Link to="/blog-grid">Dealer</Link></li>
									<li><Link to="/blog-grid">Oil Change</Link></li>
									<li><Link to="/blog-grid">Body Color</Link></li>
								</ul>
							</div> */}
							{/* Banner Widget */}
							<div className="widget ltn__banner-widget d-none go-top">
								<Link to="/project"><img src={publicUrl + "assets/img/banner/2.jpg"} alt="#" /></Link>
							</div>
						</aside>
					</div>
				</div>
			</div>
		</div>
	}
}

export default withParams(ShopDetails);